import i18n from "i18next";

export default i18n;
//export t for pure function use, see https://github.com/i18next/i18next/issues/1287
const t = i18n.t.bind(i18n);
export { t };
